import wrapError from "@/components/helpers/wrapError"

export const apiValidateSubdomain = (subdomain, success, error) => {
  $.ajax({
    type: "GET",
    url: `/api/validSubdomain?subdomain=${subdomain}`,
    success,
    error: wrapError(error, "validateSubdomain"),
  })
}

export const apiFetchTicket = (ticketId, success, error) => {
  $.ajax({
    type: "GET",
    url: `/api/customerCreationTicket/${ticketId}`,
    success,
    error: wrapError(error, "customerCreationTicket GET"),
  })
}

export const apiConnectUser = (ticketId, params, success, error) => {
  $.ajax({
    type: "POST",
    url: `/api/customerCreationTicket/${ticketId}`,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "apiConnectUser"),
  })
}

export const apiCreateCustomerAvatar = (params, success, error) => {
  $.ajax({
    url: "/api/admin/avatarCreationManager",
    type: "POST",
    dataType: "JSON",
    data: params,
    success,
    error: wrapError(error, "saveAvatar"),
  })
}

export const apiCreateCustomer = (params, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/customers",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "apiCreateCustomer"),
  })
}
